import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getAnalytics, isSupported } from "firebase/analytics";



// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDmSTpD3KGg40gWggOQibefc4bs3SDvMTg",
  authDomain: "cancionesia.firebaseapp.com",
  projectId: "cancionesia",
  storageBucket: "cancionesia.firebasestorage.app",
  messagingSenderId: "555979432649",
  appId: "1:555979432649:web:4a17b29cb895ecef246318",
  measurementId: "G-MHF9HL87XP"
};

const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const db = getFirestore(app);
export const auth = getAuth(app);

// ✅ IMPORTANTE: usa tu SITE KEY de reCAPTCHA v3 (App Check)
export const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY),
  isTokenAutoRefreshEnabled: true,
});

console.log("SITE KEY:", process.env.REACT_APP_RECAPTCHA_SITE_KEY);
// ✅ Analytics (solo si el navegador lo soporta)
export let analytics = null;
isSupported().then((yes) => {
  if (yes) analytics = getAnalytics(app);
});